import { Spin } from "antd";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import {
  ContainerLayout,
  ContentLayout,
  ContentStyled,
} from "./OsosOnboardingLayout.styles";

function OsosOnboardingLayout() {
  return (
    <ContainerLayout>
      <ContentLayout>
        <ContentStyled>
          <Suspense fallback={<Spin />}>
            <Outlet />
          </Suspense>
        </ContentStyled>
      </ContentLayout>
    </ContainerLayout>
  );
}

export default OsosOnboardingLayout;
